import i18n from "@/plugins/i18n";

export function useLocalizedPath() {
    const getLocalizedPath = (path) => {
      return i18n.global.locale.value === 'ru' ? path : `/${i18n.global.locale.value}${path}`
    }

    return { getLocalizedPath };
}